import {Injectable, OnDestroy} from '@angular/core';
import {AbstractFindAllService} from '../../../core/service/v2/service/findAll/abstractFindAll.service';
import {ProductModel} from '../../api/entity/product.model';
import {ProductSummaryModel} from '../../api/entity/productSummary.model';
import {ProductRepository} from './ngrx-data/product.repository';
import {ProductSummaryDataServiceAdapter} from './ngrx-data/productSummaryDataService.adapter';

@Injectable()
export class ProductFindAllService extends AbstractFindAllService<ProductModel, ProductSummaryModel>
    implements OnDestroy{

    constructor(repository: ProductRepository, dataServiceAdapter: ProductSummaryDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
    ngOnDestroy(): void {
        super.onDestroy();
    }
}
